import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SerialNumbers_ds_get_serialnumber_by_serialnumberIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { serialnumberIds: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, ChainHead?: number, LookupCode?: string, ParentSerialNumber?: { LookupCode?: string, ParentSerialNumber?: { LookupCode?: string, ParentSerialNumber?: { LookupCode?: string, ParentSerialNumber?: { LookupCode?: string } } } }, Status?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialnumberIds)) {
      missingRequiredInParams.push('\'serialnumberIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumber_by_serialnumberIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { serialnumberIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, ChainHead?: number, LookupCode?: string, ParentSerialNumber?: { LookupCode?: string, ParentSerialNumber?: { LookupCode?: string, ParentSerialNumber?: { LookupCode?: string, ParentSerialNumber?: { LookupCode?: string } } } }, Status?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialnumberIds)) {
      missingRequiredInParams.push('\'serialnumberIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumber_by_serialnumberIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { serialnumberIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, ChainHead?: number, LookupCode?: string, ParentSerialNumber?: { LookupCode?: string, ParentSerialNumber?: { LookupCode?: string, ParentSerialNumber?: { LookupCode?: string, ParentSerialNumber?: { LookupCode?: string } } } }, Status?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialnumberIds)) {
      missingRequiredInParams.push('\'serialnumberIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumber_by_serialnumberIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      serialnumberIds: number[]    }) {
        if(isNil(inParams.serialnumberIds)) {
          return true; 
        }
      return false;
    }
}
